<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
import StrIyilestirmeBirim from "@/models/StrIyilestirmeBirim";  
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
import store from "@/state/store";
export default {
  mixins: [Api, Sabit, StrIyilestirmeBirim],
  page: {
    title: "İyileştirme Raporu",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader, formcombobox, BirimSecimi
  },
  data() {
    return {
      title: "İyileştirme Raporu",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "İyileştirme İşlemleri",
        },
        {
          text: "İyileştirme Raporu",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Filter: {
        Birimid: null,
        Donemid: null,
        Durum: null
      },
      Userid: store.getters["auth/TokenUserId"],  
    };
  },

  methods: {
    Get() { this.FilterGet() },
    FilterGet() {

 
        var Filter = ""
        if (this.Filter.Iyilestirmeid != null) { Filter += "&Iyilestirmeid=" + this.Filter.Iyilestirmeid } 
        if (this.Filter.Birimid != null) { Filter += "&Birimid=" + this.Filter.Birimid }
        this.ActionsFilterGet({ Service: "StrIyilestirmeBirim/GetBirimIylestirmeRaporu", Page: this.Page, Filter: Filter }).then((res) => {
          this.TableData = res.Data;
          this.Page.PageDataSize = res.TotalCount;
        });
   
    },
  
  },
};
</script>
 

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">

                <formcombobox class="col-md-3" :FormDataType="FormDataType.Iyilestirmeid" :Value="Filter.Iyilestirmeid"
                  :v="$v.Filter.Iyilestirmeid" @input="Filter.Iyilestirmeid = $event" />
 
                <BirimSecimi class="mb-3 col-md-3" :title="FormDataType.Birimid.FieldTitle" :sutun="'0'"
                  :title_position="'mb-3'" :selected="Filter.Birimid" :labels_lg="'3'" :v="$v.Filter.Birimid"
                  :multiple="false" :BirimTipId="null" @Secilmis_Idler="Filter.Birimid = $event" :YetkiKontrol=1 />

                <div class="col-sm-4 ">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2 mt-4" @click="FilterGet()"> <i
                      class="mdi mdi-text-search me-1"></i>Filtreleme</button>
                </div>


                <div class="col-sm-2 ">
                  <div class="text-sm-end"> 
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Gelişmeye Açık Yön</th>
                      <th>Sorumlu Birim/Birimler</th>
                      <th>Planlanan İyileştirme</th>
                      <th>Yapılan İyileştirme Tarihi</th> 
                      <th>Gerçekleşme Durumu</th>
                      <th>Kanıt</th> 
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id" >
                      <th scope="row">{{ Data.Gelistirme }}</th>
                      <td>{{ Data.Birimadi }}</td>
                      <td>{{ Data.Planlananiyilestirme }}</td>
                      <td>{{ Data.Bitisay }} / {{ Data.Bitisyil }}</td>
                      <td>{{ DurumEnum[Data.Durum] }}</td>
                      <td>{{ Data.Kanit }}</td>  
                     
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
 
    </Layout>
  </Loader>
</template>
